<template>
  <footer>
    <div style="width: 100%;margin: 0;">
      <ul>
        <li>
          <p> アクロニムテクノロジ―</p>
        </li>
      </ul>
      <p>{{address}}
      </p>
      <!-- Copyright©2018 www..com All Rights Reserved -->
    </div>
  </footer>
</template>

<script>
export default {
  data () {
    return {}
  },
  computed: {
     title () {
        return ''
    },
    address () {
       return this.$store.getters.currentLang === 'zh' ? '电话：092-791-7271 地址：810-0016福冈县福冈市中央区平和5-13-42' : 'お電話:092-791-7271住所:810-0016福岡県福岡市中央区平和5-13-42'
    }
  }
}
</script>

<style scoped lang="scss">
footer {
  width: 100%;
  height: 150px;
  background: $luck_black;
  > div {
    width: 960px;
    height: inherit;
    margin: 0 auto;
    text-align: center;
    > div {
      width: inherit;
      height: 100px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      > img {
        padding-top: 30px;
        width: 140px;
      }
    }
    > ul {
        padding-top: 30px;
      // margin-top: 60px;
      margin-bottom: 20px;
      display: flex;
      justify-content: center;
      color: rgba(255, 255, 255, 0.2);
      > li {
        float: left;
        margin-right: 10px;
        cursor: pointer;
      }
    }
    > p {
      margin: 0 auto;
      width: 600px;
      color: rgba(255, 255, 255, 0.2);
    }
  }
}
</style>